import { action, computed, observable } from "mobx";
import { persist } from "mobx-persist";
import { IUserInfo } from "./core/interfaces/user";

export default class AppStore {
  @persist
  @observable
  token?: string;

  @persist
  @observable
  osType?: string;

  @persist('object')
  @observable
  userInfo?: IUserInfo;

  @persist
  @observable
  answerId?: number;

  @persist
  @observable
  questionId?: number;

  @persist
  @observable
  previousPathForFailedLogin?: string;

  @persist
  @observable
  isPaycellLoggedBefore: boolean = false;

  @observable
  correctAnswerIndex?: number;

  @observable
  chosenAnswerIndex?: number;

  @observable
  isUserWinThreeStampModalVisible: boolean = false;

  @observable
  isUserAnsweredWrongThirdQuestionModalVisible: boolean = false;

  @observable
  isOfferAccepting: boolean = false;

  @observable
  is500MBModalVisible: boolean = false;

  @observable
  is1GBWinModalVisible: boolean = false;

  @observable
  isUnknownErrorModalVisible: boolean = false;

  @observable
  isAnswerValidationModalVisible: boolean = false;

  @observable
  isAnswerCorrect: boolean = false;

  @observable
  isCongratulationsModalVisible: boolean = false;

  @observable
  tokenBalance?: number;

  @computed
  get isLoggedIn(): boolean {
    return this.token ? true : false;
  }

  @action
  setToken = async (token?: string) => {
    this.token = token;
  };

  @action
  setOsType = async (osType?: string) => {
    this.osType = osType;
  };

  @action
  setUser = (userInfo?: IUserInfo) => {
    this.userInfo = userInfo ? {
      ...this.userInfo,
      ...userInfo
    } : this.userInfo;
  };

  @action
  handleUnknownErrorModalVisibility = (
    isUnknownErrorModalVisible: boolean
  ): void => {
    this.isUnknownErrorModalVisible = isUnknownErrorModalVisible;
  };

  @action
  resetAnswerSelection = (): void => {
    this.isAnswerValidationModalVisible = false;
    this.isOfferAccepting = false;
    this.chosenAnswerIndex = undefined;
    this.answerId = undefined;
    this.correctAnswerIndex = undefined;
  };
}
